import {
    Component,
    ElementRef,
    HostBinding,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
} from "@angular/core";
import {
    style,
    animate,
    AnimationBuilder,
    AnimationPlayer,
} from "@angular/animations";
import { WtfAnimations } from "../../../../utils/others/core/animations";

@Component({
    selector: "wtf-filter-panel",
    templateUrl: "./filter-panel.component.html",
    styleUrls: ["./filter-panel.component.scss"],
    animations: WtfAnimations,
})
export class FilterPanelComponent implements OnInit {
    @ViewChild("openButton", { static: true }) openButton;
    @ViewChild("panel", { static: true }) panel;
    @ViewChild("overlay", { static: true }) overlay: ElementRef;

    public player: AnimationPlayer;

    @HostBinding("class.bar-closed") barClosed: boolean;

    constructor(
        private animationBuilder: AnimationBuilder,
        private renderer: Renderer2
    ) {
        this.barClosed = true;

        // Get the nav model and add customize nav item
        // that opens the bar programmatically
        /*    const navModel = this.navigationService.getNavigationModel();

        navModel.push({
            'id'      : 'custom-function',
            'title'   : 'Custom Function',
            'type'    : 'group',
            'children': [
                {
                    'id'      : 'customize',
                    'title'   : 'Customize',
                    'type'    : 'item',
                    'icon'    : 'settings',
                    'function': () => {
                        this.openBar();
                    }
                }
            ]
        });*/
    }

    ngOnInit() {
        this.renderer.listen(this.overlay.nativeElement, "click", () => {
            this.closeBar();
        });
    }

    onSettingsChange() {}

    closeBar() {
        this.player = this.animationBuilder
            .build([
                style({ transform: "translate3d(0,0,0)" }),
                animate(
                    "50ms ease",
                    style({ transform: "translate3d(0,0,0)" })
                ),
            ])
            .create(this.panel.nativeElement);

        this.player.play();

        this.player.onDone(() => {
            this.barClosed = true;
        });
    }

    openBar() {
        this.barClosed = false;

        this.player = this.animationBuilder
            .build([
                style({ transform: "translate3d(0,5%,0)" }),
                animate(
                    "400ms ease",
                    style({ transform: "translate3d(0,0,0)" })
                ),
            ])
            .create(this.panel.nativeElement);

        this.player.play();
    }
}
